import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { applyTenant, readTenant } from './lib/tenant';
import { getTheme } from './lib/theme';
import './styles/app.css';

const tenant = readTenant();

// The Worker set data-theme from the cookie before paint; a browser without the cookie but with the
// stored preference gets it here, before React mounts.
document.documentElement.setAttribute('data-theme', getTheme());
applyTenant(tenant);

const root = document.getElementById('root');
if (!root) throw new Error('missing #root');

createRoot(root).render(
  <StrictMode>
    <App tenant={tenant} />
  </StrictMode>,
);

// The service worker is for the installed app. In development it would cache the dev server's
// modules and mask every edit, so it registers under every other APP_ENV (production, and test so
// the browser suite can prove the offline path).
if (tenant.app_env !== 'development' && 'serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register(`/sw.js?v=${encodeURIComponent(tenant.git_sha)}`).catch(() => {
      // An installed worker is a convenience; the app works without one.
    });
  });
}
